export default [
    {
        key: 'address',
        label: '地址',
        icon: require('../images/contactus_icon_locate@2x.png')
    },
    {
        key: 'postal',
        label: '邮编',
        icon: require('../images/contactus_icon_zipcode@2x.png')
    },
    {
        key: 'phone',
        label: '电话',
        icon: require('../images/contactus_icon_tel@2x.png')
    },
    {
        key: 'fax',
        label: '传真',
        icon: require('../images/contactus_icon_fax@2x.png')
    },
    {
        key: 'email',
        label: '邮箱',
        icon: require('../images/contactus_icon_email@2x.png')
    }
]
